module.exports = __webpack_public_path__ + "img/图1-21圆规及其附件.d804e18c.jpg";